<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.account-selection.title'">
    <wbo-text-column field="accountName" [title]="'wbo.report.account-selection.column.accountName'"></wbo-text-column>
    <wbo-text-column field="accountNo" [title]="'wbo.report.account-selection.column.accountNo'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromAccount([$event])">
            <wbo-account-single-select-edit-control></wbo-account-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="AccountSearchPageComponent" (onSelect)="addFromAccount($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
